var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading && _vm.records.length
            ? _c("div", [
                _c(
                  "table",
                  { staticClass: "table table-sm table-hover mt-1" },
                  [
                    _c("thead"),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.records, function (rev) {
                          return [
                            _c("tr", [
                              _c("td", { attrs: { colspan: "10" } }, [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.printDate(rev.date, "DD.MM.YYYY")
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm._l(rev.divisions, function (d, i) {
                              return _c("tr", [
                                _c("td", [_vm._v(_vm._s(i + 1))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$AllDivisions[d.division_id]?.title
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    d.user_id
                                      ? _c("UserName", {
                                          attrs: { id: d.user_id },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$AllCurrencies[d.currency_id]
                                        ?.currency
                                    ) + ": "
                                  ),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(d.sum.toLocaleString("ru-RU"))
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(d.extra_currencies))]),
                              ])
                            }),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }